// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'F:/workplace/aiProvide/src/models/arithManage';
import model_3 from 'F:/workplace/aiProvide/src/models/measurer';
import model_4 from 'F:/workplace/aiProvide/src/models/meatypeManage';
import model_5 from 'F:/workplace/aiProvide/src/models/propertyManage';
import model_6 from 'F:/workplace/aiProvide/src/models/token';
import model_7 from 'F:/workplace/aiProvide/src/models/userManage';
import model_8 from 'F:/workplace/aiProvide/src/.umi-production/plugin-initialState/@@initialState';
import model_2 from 'F:/workplace/aiProvide/src/models/dictionary';

export const models = {
model_1: { namespace: 'arithManage', model: model_1 },
model_3: { namespace: 'measurer', model: model_3 },
model_4: { namespace: 'meatypeManage', model: model_4 },
model_5: { namespace: 'propertyManage', model: model_5 },
model_6: { namespace: 'token', model: model_6 },
model_7: { namespace: 'userManage', model: model_7 },
model_8: { namespace: '@@initialState', model: model_8 },
model_2: { namespace: 'dictionary', model: model_2 },
} as const
